import css from "styled-jsx/css";

export const componentStyles = css`
  .youtube-text-and-asset-component {
  }
`;
